module.exports = __webpack_public_path__ + "static/media/laptop.b03d0b53.svg";